import React, { useEffect } from 'react'
import { Typography } from '@material-ui/core'
import PublicWrapper from '../public-wrapper-v2/public-wrapper'
import useVerifyEmailStyles from './verify-email.styles'
import STATIC_TEXT from '../../content/common.json'
import { saveUserEmailAction } from '../../stores/user/user-action'
import { useDispatch } from 'react-redux'

export const VerifyEmail = () => {
    const classes = useVerifyEmailStyles()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(saveUserEmailAction(null))
    }, [])

    return (
        <div className={classes.trapezoidBgVerifyEmail}>
            <PublicWrapper data-testid="publicWrapper" displayPrivacyPolicyFooter={true} backgroundClass={classes.root}>
                <div>
                    <Typography
                        variant="h2"
                        className={classes.header}
                        style={{
                            width: '692px',
                            fontWeight: '700',
                            fontSize: '42px',
                            color: '#212121',
                            marginTop: '106px',
                            lineHeight: '58px'
                        }}
                    >
                        {STATIC_TEXT.login.GreatCheckYourEmailTitle}
                    </Typography>
                    <Typography
                        variant="body2"
                        className={classes.emailText}
                        style={{
                            width: '660px',
                            fontWeight: '500',
                            fontSize: '24px',
                            color: '#212121',
                            marginTop: '30px',
                            lineHeight: '34px',
                            wordBreak: 'keep-all'
                        }}
                    >
                        <span style={{ color: '#212121' }}>
                            {STATIC_TEXT.login.CheckYourEmailMessage2} <b>{STATIC_TEXT.login.CheckYourEmailMessage3}</b>{' '}
                            {STATIC_TEXT.login.CheckYourEmailMessage4}
                            <br />
                            <br />
                            {STATIC_TEXT.login.CheckYourEmailMessage5}
                        </span>
                        <span style={{ color: '#007DB8' }}>
                            {' '}
                            <a href={`mailto:${STATIC_TEXT.login.SupportEmail}`} className={classes.link}>
                                LendX Support.
                            </a>{' '}
                        </span>
                    </Typography>
                </div>
            </PublicWrapper>
        </div>
    )
}
